import { useState } from "react";
import { Outlet, Navigate, Link } from "react-router-dom";
import { Menu, X } from "lucide-react";
import DashboardSidebar from "./DashboardSidebar";
import CommandPalette from "./CommandPalette";
import AICopilot from "./AICopilot";
import TrialExpiredModal from "./TrialExpiredModal";
import { useAuth } from "../context/AuthContext";
import { Toaster } from "./ui/sonner";

export default function DashboardLayout() {
  const { user, loading } = useAuth();
  const [mobileOpen, setMobileOpen] = useState(false);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center text-sm text-zinc-500">Chargement...</div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (!user.onboarding_completed) return <Navigate to="/onboarding" replace />;

  return (
    <div className="min-h-screen flex bg-[#FAFAFA]">
      {/* Mobile header bar */}
      <header className="md:hidden fixed top-0 inset-x-0 h-14 bg-white border-b border-zinc-200 flex items-center justify-between px-4 z-40">
        <Link to="/" className="flex items-center gap-2" data-testid="mobile-logo">
          <div className="w-7 h-7 klein-bg rounded-sm flex items-center justify-center">
            <span className="font-display text-white font-bold text-sm">F</span>
          </div>
          <span className="font-display font-semibold tracking-tight">FlowMind</span>
        </Link>
        <button
          onClick={() => setMobileOpen(true)}
          className="w-9 h-9 flex items-center justify-center rounded-sm border border-zinc-200"
          aria-label="Menu"
          data-testid="mobile-menu-toggle"
        >
          <Menu size={18}/>
        </button>
      </header>

      {/* Sidebar: hidden on mobile, visible on md+ */}
      <div className="hidden md:flex">
        <DashboardSidebar />
      </div>

      {/* Mobile drawer */}
      {mobileOpen && (
        <div className="md:hidden fixed inset-0 z-50 flex" data-testid="mobile-drawer">
          <div className="absolute inset-0 bg-black/40" onClick={() => setMobileOpen(false)}/>
          <div className="relative bg-white w-72 max-w-[85vw] h-full overflow-y-auto">
            <button
              onClick={() => setMobileOpen(false)}
              className="absolute top-3 right-3 w-9 h-9 flex items-center justify-center rounded-sm hover:bg-zinc-100"
              aria-label="Fermer"
              data-testid="mobile-drawer-close"
            >
              <X size={18}/>
            </button>
            <div onClick={() => setMobileOpen(false)}>
              <DashboardSidebar />
            </div>
          </div>
        </div>
      )}

      <main className="flex-1 min-w-0 pt-14 md:pt-0">
        <Outlet />
      </main>
      <CommandPalette />
      <AICopilot />
      <TrialExpiredModal />
      <Toaster />
    </div>
  );
}
